import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VBottomSheet,
    {
      attrs: { value: _vm.isVisibleBottomSheet },
      on: { input: _vm.emitClose },
    },
    [
      _c(
        VSheet,
        { staticClass: "pa-4" },
        [
          _c(
            "div",
            { staticClass: "lpu-schedule mb-6" },
            [
              _c("div", { staticClass: "text-h6 text--text mb-4" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("График работы", _vm.options)) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _vm.isVisibleSkeleton
                ? _c("LpuScheduleSkeleton")
                : [
                    _c(
                      "div",
                      { staticClass: "lpu-schedule__days" },
                      _vm._l(_vm.schedule.schedule_days, function (time, day) {
                        return _c(
                          "div",
                          {
                            key: day,
                            staticClass: "lpu-schedule__day",
                            class: {
                              "text-subtitle-1 lpu-schedule__day--current":
                                day === _vm.schedule.now_weekday_translit,
                              "text-body-1":
                                day !== _vm.schedule.now_weekday_translit,
                            },
                          },
                          [
                            _c("div", { staticClass: "lpu-schedule__item" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      _vm.schedule.full_days[day],
                                      _vm.options
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "lpu-schedule__item" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(time, _vm.options)) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.schedule.lpu_exceptions.length
                      ? _c("div", { staticClass: "mt-6" }, [
                          _c(
                            "div",
                            { staticClass: "text-h6 text--text mb-4" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "График работы в праздничные дни",
                                      _vm.options
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "lpu-schedule__days" },
                            _vm._l(
                              _vm.schedule.lpu_exceptions,
                              function (exception, index) {
                                return _c(
                                  "div",
                                  {
                                    key: `holiday-${index}`,
                                    staticClass:
                                      "lpu-schedule__day text-body-1",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "lpu-schedule__item" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                exception.date,
                                                _vm.options
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "lpu-schedule__item" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                exception.time,
                                                _vm.options
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            VBtn,
            {
              staticClass: "branding-btn branding-btn--primary",
              attrs: { block: "", depressed: "", color: "primary" },
              on: { click: _vm.emitClose },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("Понятно", _vm.options)) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }